import { EligiblePaymentMethod } from 'types/api/tickets.types';

export const TICKETS_CONFIRMATION_ORDER_STORAGE_KEY = 'nf-tickets-order-id';
export const MAX_CART_ITEMS = 20;
export const DEFAULT_CURRENCY = 'SAR';
export const AED_CURRENCY = 'AED';
export const TICKET_SHARE_CODE_KEY = 'nf-tickets-share-code';
// Supporting macOS 12.3 and iOS 15.4 or later
// A list of available versions is here https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_on_the_web_version_history
export const APPLE_PAY_VERSION = 13;

export const paymentMethodIntlIdLookup: Record<EligiblePaymentMethod, string> =
  {
    ApplePay: 'checkout.payment.method.apple.pay',
    CreditCard: 'checkout.payment.method.credit.card',
    TabbyPay: 'checkout.payment.method.tabby',
  };

// Type for supported countries that must be in ALPHA2_COUNTRY_CODES
export type TabbySupportedCountryCode = 'SA' | 'AE';
type TabbySupportedCurrency = 'SAR' | 'AED';

// Type for the mapping structure - only for countries we support
type TabbyCountryCurrencyMapping = Record<
  TabbySupportedCountryCode,
  {
    countryCode: TabbySupportedCountryCode;
    currency: TabbySupportedCurrency;
    tabbySupported: boolean;
  }
>;

export const TabbyCountriesAndCurrenciesMapping: TabbyCountryCurrencyMapping = {
  SA: {
    countryCode: 'SA',
    currency: DEFAULT_CURRENCY,
    tabbySupported: true,
  },
  AE: {
    countryCode: 'AE',
    currency: AED_CURRENCY,
    tabbySupported: true,
  },
} as const;
